export const flag = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 24 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.042 27.2496L13.9526 23.75H11.7295C8.51563 23.75 5.78534 22.6266 3.53862 20.3799C1.2919 18.1332 0.168021 15.4024 0.166993 12.1875C0.165965 8.97261 1.28984 6.24232 3.53862 3.99662C5.7874 1.75093 8.51769 0.627056 11.7295 0.625C13.3369 0.625 14.8416 0.926139 16.2435 1.52842C17.6454 2.12967 18.87 2.95394 19.9173 4.00125C20.9646 5.04856 21.7889 6.27264 22.3901 7.6735C22.9914 9.07642 23.292 10.5811 23.292 12.1875C23.292 13.759 23.0613 15.2683 22.5998 16.7154C22.1383 18.1625 21.5001 19.5299 20.685 20.8178C19.87 22.1056 18.8936 23.2926 17.7559 24.379C16.6181 25.4654 15.3802 26.4217 14.042 27.248M15.5837 24.2896C17.408 22.7479 18.8921 20.9431 20.036 18.8753C21.1799 16.8074 21.7514 14.5781 21.7503 12.1875C21.7503 9.38681 20.7801 7.01675 18.8397 5.07733C16.8992 3.13792 14.5292 2.16769 11.7295 2.16667C8.92983 2.16564 6.55977 3.13586 4.61933 5.07733C2.67888 7.01881 1.70866 9.38886 1.70866 12.1875C1.70866 14.9861 2.67888 17.3567 4.61933 19.2992C6.55977 21.2417 8.92983 22.2114 11.7295 22.2083H15.5837V24.2896ZM11.7804 20.0053C12.099 20.0053 12.3677 19.8958 12.5867 19.6769C12.8056 19.458 12.915 19.1892 12.915 18.8706C12.915 18.552 12.8056 18.2833 12.5867 18.0643C12.3677 17.8454 12.099 17.7354 11.7804 17.7344C11.4618 17.7344 11.193 17.8444 10.9741 18.0643C10.7541 18.2833 10.6442 18.552 10.6442 18.8706C10.6442 19.1892 10.7536 19.458 10.9725 19.6769C11.1925 19.8958 11.4618 20.0053 11.7804 20.0053ZM11.1067 15.4959H12.471C12.5101 14.8638 12.6314 14.3638 12.8349 13.9959C13.0384 13.629 13.5214 13.0637 14.284 12.3C14.728 11.8581 15.0795 11.4064 15.3385 10.9449C15.5965 10.4845 15.7255 9.9562 15.7255 9.36008C15.7255 8.247 15.3416 7.37288 14.5739 6.73771C13.8061 6.10254 12.8775 5.78444 11.7881 5.78342C10.8353 5.78342 10.0285 6.04396 9.36766 6.56504C8.70474 7.08613 8.21912 7.70742 7.91078 8.42892L9.17958 8.92071C9.38719 8.46437 9.69038 8.04864 10.0892 7.6735C10.489 7.29939 11.0553 7.11233 11.7881 7.11233C12.6596 7.11233 13.3035 7.34924 13.7198 7.82304C14.136 8.29788 14.3442 8.81588 14.3442 9.37704C14.3442 9.89299 14.2105 10.3293 13.9433 10.6859C13.6771 11.0426 13.3344 11.4305 12.915 11.8499C12.174 12.5025 11.6874 13.0883 11.4551 13.6074C11.2228 14.1264 11.1067 14.7559 11.1067 15.4959Z"
      fill="black"
    />
  </svg>
);

export const CCMIcon = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6505 5.34748C10.6504 6.18831 10.3163 6.99467 9.72175 7.58919C9.12715 8.18371 8.32075 8.5177 7.47992 8.5177C7.06354 8.51781 6.65123 8.4359 6.26651 8.27666C5.88179 8.11742 5.53221 7.88396 5.23771 7.58961C4.94322 7.29526 4.70959 6.94579 4.55015 6.56116C4.39072 6.17652 4.3086 5.76424 4.3085 5.34787V5.34748C4.3086 4.50664 4.6427 3.70028 5.23729 3.10576C5.83189 2.51124 6.63829 2.17725 7.47912 2.17725C7.89553 2.17714 8.30788 2.25906 8.69262 2.41833C9.07736 2.5776 9.42697 2.81109 9.72147 3.10548C10.016 3.39987 10.2496 3.74938 10.409 4.13407C10.5684 4.51875 10.6505 4.93107 10.6505 5.34748ZM12.9381 16.2064C12.9262 16.4767 12.6261 16.5749 12.2438 16.6283C9.75675 16.9735 5.34835 16.8658 4.15294 16.2574C2.00752 15.1657 2.10133 12.9649 3.58967 11.262C4.96321 9.69135 7.01758 9.25673 8.90175 9.64108C10.7265 10.014 13.0889 12.7484 12.9381 16.2064Z"
      stroke="white"
      stroke-width="0.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.9341 12.1242C12.9751 11.5926 14.7599 11.6068 15.7487 12.5913C16.7838 13.6208 16.6374 14.7316 15.9617 15.5363C15.4154 16.1874 13.5103 16.5825 12.6248 16.5429M15.6193 8.75368C15.6192 9.28832 15.4067 9.80103 15.0287 10.1791C14.6506 10.5571 14.1379 10.7696 13.6033 10.7697C13.3385 10.7697 13.0763 10.7176 12.8317 10.6163C12.587 10.515 12.3648 10.3665 12.1775 10.1793C11.9903 9.99213 11.8417 9.76987 11.7404 9.52525C11.6391 9.28064 11.5869 9.01846 11.5869 8.75368C11.5869 8.2189 11.7994 7.70603 12.1775 7.32789C12.5556 6.94974 13.0685 6.7373 13.6033 6.7373C14.1381 6.7373 14.6509 6.94974 15.0291 7.32789C15.4072 7.70603 15.6193 8.2189 15.6193 8.75368Z"
      stroke="white"
      stroke-width="0.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const RPMIcon = (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.667 1.875H2.33366C1.68933 1.875 1.16699 2.43464 1.16699 3.125V9.375C1.16699 10.0654 1.68933 10.625 2.33366 10.625H11.667C12.3113 10.625 12.8337 10.0654 12.8337 9.375V3.125C12.8337 2.43464 12.3113 1.875 11.667 1.875Z"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.66699 13.125H9.33366"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 10.625V13.125"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
